import { ADD_MEMBERS, AddMembersService, toastr, REDIRECT, UNPROCESSABLE_ENTITY_RESPONSE_CODE, SUCCESS_REPONSE_CODE, 
         handleOtherResponseCode, CustomToastrAction } from "@/imports-files/pages/clients/company/add-members";
import { MyTeamService } from "@/services/pages/clients/my-team-service";

export class AddMembersAction
{

  constructor(setLoader)
  {
    this.AddMembersService   =  new AddMembersService();
    this.MyTeamService       =  new MyTeamService();
    this.setLoader           =  setLoader;
    this.customToastrAction  =  new CustomToastrAction(); 

  }


  async addTeamMembers(params, router)
  {  
    this.setLoader(true);
    const body        = { client: {id: params.client.id, client_users_attributes: params.client.client_users_attributes}} 
    const result      = await this.AddMembersService.addMembers(body);
    const status_code = result.status || result.response.status;
    
    
    switch (status_code)
    {  
      case SUCCESS_REPONSE_CODE:
        this.setLoader(false);
        this.customToastrAction.setNormalToastr(result.data.success, 'success');
        // toastr.success(result.data.success)
        router.push(REDIRECT.client.company.add_team);
        break;
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        this.setLoader(false);
        let error = result.response.data.error.client.base
        //this.customToastrAction.setNormalToastr(error, 'warning');
        // toastr.warning(error);
        return result.response.data.error
        break;
      default: 
        this.setLoader(false);
        handleOtherResponseCode(status_code, args.router);
    }
  }

  async onAdminUserRemove(...args) 
  {
    // ---------------------------- Initialization ------------------------------
    const formik                    =   args[0];
    const action                    =   args[1];
    const setAdminCount             =   args[2];
    const index                     =   args[3]!=undefined ? args[3] : '';
    const queryClient               =   args[4];
    const loader                    =   args[5];
    const client_users_attributes   =   formik.values.client.client_users_attributes;
    const client                    =   formik.values.client
    // ---------------------------- Initialization ------------------------------
    
    client_users_attributes[index]['_destroy'] = true;

    // formik.current.setValues({client, client_users_attributes});
    formik.setValues({client, client_users_attributes});
    var records_length = client_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
    await queryClient.setQueryData('add-user-data', client_users_attributes);
    setAdminCount(records_length);
  }

  async onAdminUserAdd(...args) 
  {
    // ---------------------------- Initialization ------------------------------
    const formik                    =   args[0]?.current;
    const action                    =   args[1];
    const setAdminCount             =   args[2];
    const queryClient               =   args[3];
    const client_users_attributes   =   formik.values.client.client_users_attributes;
    const client                    =   formik.values.client
    // ---------------------------- Initialization ------------------------------

      client_users_attributes.push({
                                      role_id: "",
                                      status_id: "",
                                      _destroy: false,
                                      user_attributes:{
                                                        name: '',
                                                        email: ''
                                                      }
                                  })

    // formik.current.setValues({client, client_users_attributes});
    formik.setValues({client, client_users_attributes});
    var records_length = client_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
    await queryClient.setQueryData('add-user-data', client_users_attributes);
    setAdminCount(records_length);
  }

  async onAdminUserAdd(...args) 
  {
    // ---------------------------- Initialization ------------------------------
    const formik                    =   args[0]?.current;
    const action                    =   args[1];
    const setAdminCount             =   args[2];
    const queryClient               =   args[3];
    const client_users_attributes   =   formik.values.client.client_users_attributes;
    const client                    =   formik.values.client
    // ---------------------------- Initialization ------------------------------

      client_users_attributes.push({
                                      role_id: "",
                                      status_id: "",
                                      _destroy: false,
                                      user_attributes:{
                                                        name: '',
                                                        email: ''
                                                      }
                                  })

    // formik.current.setValues({client, client_users_attributes});
    formik.setValues({client, client_users_attributes});
    var records_length = client_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
    await queryClient.setQueryData('add-user-data', client_users_attributes);
    setAdminCount(records_length);
  }

  async onAdminUserRemove(...args) 
  {
    // ---------------------------- Initialization ------------------------------
    const formik                    =   args[0];
    const action                    =   args[1];
    const setAdminCount             =   args[2];
    const index                     =   args[3]!=undefined ? args[3] : '';
    const queryClient               =   args[4];
    const client_users_attributes   =   formik.values.client.client_users_attributes;
    const client                    =   formik.values.client
    // ---------------------------- Initialization ------------------------------
    
    client_users_attributes[index]['_destroy'] = true;

    // formik.current.setValues({client, client_users_attributes});
    formik.setValues({client, client_users_attributes});
    var records_length = client_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
    await queryClient.setQueryData('add-user-data', client_users_attributes);
    setAdminCount(records_length);
  }

  async handelFileChange(data, formik, userRoles, fileInfo)
  {
    this.setLoader(true);
    var fileSize = this.fileSizeValid(fileInfo);
    var csvValid = this.isCSVFileValid(data, userRoles);
    if(!(fileSize && csvValid) )
    {
      this.setLoader(false);
      return false;
    }
    else
    {
      // TODO : - set the errors in the formik schema
          const client_users_attributes = formik.current.values.client.client_users_attributes;
          const client                  = formik.current.values.client
      // ---------------------------- Initialization ------------------------------

      data.length > 0 ? this.remove_blank_formik_fields(formik, client, client_users_attributes) : '';

      data.map(user =>
      {
        var role_id = userRoles.findIndex(obj => obj.label === user.role)
        client_users_attributes.push({
                                        role_id: userRoles[role_id].value,
                                        _destroy: false,
                                        user_attributes:{
                                                          name: user.name,
                                                          email: user.email
                                                        }
                                    })
        return user;
      })

      
      document.getElementById('react-csv-reader-input').value = null;
      formik.current.setValues({client: {client_users_attributes}});
      formik.current.setTouched({client: {client_users_attributes}});
      this.setLoader(false);     
    }
  }

  fileSizeValid(fileInfo)
  {
      if(fileInfo.size > ADD_MEMBERS.CSV_FILE_SIZE_LIMIT)
      {
        this.customToastrAction.setNormalToastr('The file size is greater than 1MB', 'success');
        // toastr.success('The file size is greater than 1MB');
        document.getElementById('react-csv-reader-input').value = null
        return false;
      }
      else
      {
        return true;
      }
  }

  isCSVFileValid(data, userRoles)
  {
    try
    {
      for( var user of data)
      { 
        var role_id = userRoles.findIndex(obj => obj.label === user.role)
        userRoles[role_id].value;
        user.name;
        user.email;
      }

      return true;
    }
    catch(exception)
    {
        this.customToastrAction.setNormalToastr('Invalid File', 'success');
        // toastr.success('Invalid File');
        document.getElementById('react-csv-reader-input').value = null;
        return false;
    }
  }

  remove_blank_formik_fields(formik, client, client_users_attributes)
  {

    for (var index = client_users_attributes.length-1 ; index >= 0; index--)
    {
        if( client_users_attributes[index].role_id == "" &&
            client_users_attributes[index].user_attributes.name =="" &&
            client_users_attributes[index].user_attributes.email =="" )
        {
            client_users_attributes.splice(index, 1);
        }
        else
        {
          break;
        }
    }

    formik.current.setValues({client, client_users_attributes});

  }


}